import type { ActivityModule } from '../../core/activity';
import { mountLearnDecimalsAdditions } from './ui';
import levelsData from './levels.json';
import '../learn_decimals/style.css';
import './style.css';

export const learnDecimalsAdditions: ActivityModule = {
  id: 'learn_decimals_additions',
  title: 'Some decimais',
  description: 'Veja a adição com decimais e pinte os décimos nas barras pra representar o resultado.',
  ageMin: 8,
  ageMax: 12,
  difficulty: 5,
  iconPath: 'assets/gcompris-AGPL/learn_decimals_additions/icon.svg',
  category: 'aritmetica',
  totalLevels: levelsData.levels.length,
  mount: mountLearnDecimalsAdditions,
};
